import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import Swiper from 'react-id-swiper';
import { Cell, Grid, createPortal } from '@phishtool/ui';
import { StyledOverlay, StyledModal, StyledImage } from './styled';
const Modal = ({ overlayIndex, setOverlayIndex, srcs }) => {
    const [imageCount, setImageCount] = useState(0);
    const props = {
        loop: true,
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
        initialSlide: overlayIndex,
        threshold: 5,
        spaceBetween: 10,
        shouldSwiperUpdate: true,
        rebuildOnUpdate: true,
    };
    return createPortal(_jsxs(_Fragment, { children: [_jsx(StyledOverlay, {}), _jsx(StyledModal, Object.assign({ onClick: (e) => {
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-ignore
                    if (e.target.tagName !== 'SPAN') {
                        setOverlayIndex(null);
                    }
                } }, { children: _jsx(Grid, { children: _jsx(Cell, Object.assign({ start: [1, null, 2], end: [13, null, 12] }, { children: _jsx(Swiper, Object.assign({}, props, { children: srcs.map((src) => (_jsx(StyledImage, { src: src, alt: "", onLoad: () => {
                                    // force swiper to update
                                    setImageCount(imageCount + 1);
                                } }, src))) })) })) }) }))] }));
};
export default Modal;
